import React from 'react';
import { Link } from 'react-router-dom';
import { Box, List, ListItem, ListItemButton, ListItemText, Typography, Drawer, useMediaQuery, useTheme } from '@mui/material';
import { useAuth } from '../hooks/useAuth';

interface SidebarProps {
  mobileOpen?: boolean;
  onMobileClose?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ mobileOpen = false, onMobileClose }) => {
  const { signOut } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const sidebarContent = (
    <Box
      sx={{
        width: 250,
        height: '100%',
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        p: 2,
      }}
    >
      <Typography variant="h5" sx={{ mb: 2 }}>
        Coachable AI
      </Typography>
      <List>
        <ListItem disablePadding>
          <ListItemButton 
            component={Link} 
            to="/"
            onClick={isMobile ? onMobileClose : undefined}
          >
            <ListItemText primary="Dashboard" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton 
            component={Link} 
            to="/my-ais"
            onClick={isMobile ? onMobileClose : undefined}
          >
            <ListItemText primary="My AIs" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton 
            component={Link} 
            to="/review"
            onClick={isMobile ? onMobileClose : undefined}
          >
            <ListItemText primary="Review" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton 
            component={Link} 
            to="/analytics"
            onClick={isMobile ? onMobileClose : undefined}
          >
            <ListItemText primary="Analytics" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton 
            onClick={() => {
              signOut();
              if (isMobile && onMobileClose) onMobileClose();
            }}
          >
            <ListItemText primary="Sign Out" />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  if (isMobile) {
    return (
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: 250,
          },
        }}
      >
        {sidebarContent}
      </Drawer>
    );
  }

  return (
    <Box
      sx={{
        display: { xs: 'none', md: 'block' },
        minHeight: '100vh',
      }}
    >
      {sidebarContent}
    </Box>
  );
};

export default Sidebar;
